export var PermissionType;
(function (PermissionType) {
    PermissionType["READ"] = "read";
    PermissionType["WRITE"] = "write";
    PermissionType["SEARCH"] = "search";
})(PermissionType || (PermissionType = {}));
export function getPermissionTypes() {
    return Object.values(PermissionType);
}
export function getPermissionTypeFromRequestMethod(method) {
    const lcMethod = method.toLowerCase();
    return lcMethod === 'get' || lcMethod === 'head' || lcMethod === 'options'
        ? PermissionType.READ
        : PermissionType.WRITE;
}
export function matchAllPermissionTypes(types, requiredTypes) {
    for (const required of requiredTypes) {
        if (!types.find((t) => t === required)) {
            return false;
        }
    }
    return true;
}
export function getMissingPermissionTypes(types, requiredTypes) {
    return requiredTypes.filter((t) => !types.includes(t));
}
